import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { ResourceSecureUriService, ResourceService } from '@mprep/shared/data/services'
import { ResourceSecureUri, ResourceType, Resource } from '@mprep/shared/data/models'

@Component({
  selector: 'mp-video-player',
  templateUrl: './video-player.html',
  styleUrls: ['./video-player.scss']
})
export class VideoPlayerComponent implements OnInit {

  public resource: Resource
  public securedResource: ResourceSecureUri
  public ResourceType: any = ResourceType

  constructor(
    private _route: ActivatedRoute,
    private _resourceSecureUriService: ResourceSecureUriService,
    private _resourceService: ResourceService
  ) { }

  public ngOnInit() {
    this._route.params.subscribe((params) => {
      this._resourceService.findModelById(params.id).concatMap((resource) => {
        return this._resourceSecureUriService.findModelById(params.id).map((securedResource) => {
          this.securedResource = securedResource
          this.resource = resource
        })
      }).subscribe()
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/video-players/video-player/video-player.component.ts